import { render, staticRenderFns } from "./viajes.vue?vue&type=template&id=9880cc6c&scoped=true"
import script from "./viajes.vue?vue&type=script&lang=js"
export * from "./viajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9880cc6c",
  null
  
)

export default component.exports